@if (listData.dataSource.data.length) {
  <div class="resultArea">
    <table mat-table [dataSource]="listData.dataSource" matSort (matSortChange)="sortData($event)" matSortDisableClear>
      @for (col of tableColumns; track col.header) {
        <ng-container [matColumnDef]="col.columnDef">
          @if (col.sortable) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ col.header }}
            </th>
          } @else {
            <th mat-header-cell *matHeaderCellDef>
              {{ col.header }}
            </th>
          }
          <td mat-cell *matCellDef="let row; let last = last">
            {{ col.cell(row) }}
          </td>
        </ng-container>
      }
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row;">
          <button mat-icon-button type="button" (click)="toggleExpanded(row)">
            <mat-icon>{{ row.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="aktionen">
        <th mat-header-cell *matHeaderCellDef>Aktionen</th>
        <td mat-cell *matCellDef="let row;">
          <button appThrottleEvent mat-icon-button type="button" (throttleEvent)="openInPezi(row.data)"
                  matTooltip="Im Maklercockpit öffnen"
                  matTooltipClass="tooltip-multiline">
            <mat-icon>developer_board</mat-icon>
          </button>
          <!-- other actions ? -->
          @if (userService.isAuthorized$('O30_ERINNERUNG') | async) {
            <app-reminder [polizzeId]="row.data.id" [(reminder)]="row.data.reminder"></app-reminder>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef='expandedColumn'>
        <td mat-cell *matCellDef="let row;" [attr.colspan]="'100%'">
          <div class="ex-container">
            <div class="ex-element">
              <span class="ex-desc bold-text">Betreuernummer</span>
              {{ row.data.betreuernummer ? row.data.betreuernummer : '-' }}
            </div>
            <div class="ex-element">
              <span class="ex-desc bold-text ">Polizzenadresse</span>
              {{ row.data.adresse ? (row.data.adresse | formatAdress) : '-' }}
            </div>
            <div class="ex-element">
              <span class="ex-desc bold-text ">Inkassoadresse</span>
              {{ row.data.inkassoAdresse ? (row.data.inkassoAdresse | formatAdress) : '-' }}
            </div>
            <div class="ex-element">
              <span class="ex-desc bold-text ">Ablaufdatum</span>
              {{ row.data.ablaufdatum ? (row.data.ablaufdatum | formatDate) : '-' }}
            </div>
            <div class="ex-element">
              <span class="ex-desc  bold-text">Zuletzt bearbeitet von:</span>
              {{ row.data.bearbeitet.email }}
            </div>
            @if (row.data.kfzkennzeichen) {
              <div class="ex-element">
                <span class="ex-desc  bold-text">Kennzeichen (KFZ)</span>
                {{ row.data.kfzkennzeichen }}
              </div>
            }
            @if (row.data.kaskoVariante) {
              <div class="ex-element">
                <span class="ex-desc  bold-text">Kaskovariante</span>
                {{ row.data.kaskoVariante }}
              </div>
            }
            @if (row.data.selbstbehalt) {
              <div class="ex-element">
                <span class="ex-desc  bold-text">Selbstbehalt</span>
                {{ row.data.selbstbehalt }}
              </div>
            }
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="descriptions">
        <td mat-cell *matCellDef="let row;" [attr.colspan]="'100%'">
          <div class="desc-box">
            <!-- Vollmachtdokument /Genehmigungsdokument -->
            @for (documentConfigRow of documentLayoutConfig; track documentConfigRow.documentType) {
              <ng-container *ngTemplateOutlet="documentTemplate, context: {
                row, documentConfigRow
              }"></ng-container>
            }
            <!-- FREIGEBEN & ABLEHNEN -->
            <div class="add-row">
              <span class="fixed-col gray-text">Status vergeben</span>
              <span class="fixed-col">
              </span>
              @if (bearbeitenErlaubt) {
                <div class="flex-container">
                  <div class="button-col">
                    <!--
                    <button mat-raised-button class="mat-gray-bg button-right-margin flex-button"
                            (click)="antragFreigeben(row.data)">
                      Antrag freigeben
                    </button>
                    -->
                    <button mat-raised-button class="mat-gray-bg flex-button"
                            (click)="antragAblehnen(row.data)">
                      ändern/ablehnen
                    </button>
                  </div>
                  <!--
                  <mat-icon class="info-icon"
                            matTooltip="Lorem ipsum dolor sit amet, consetetur sadipscing elitr"
                            matTooltipPosition="right"
                            matTooltipClass="tooltip-multiline">info_outline
                  </mat-icon>
                  -->
                </div>
              }
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="erstellen">
        <th mat-header-cell *matHeaderCellDef>Antrag freigeben</th>
        <td mat-cell *matCellDef="let row;">
          <button mat-icon-button type="button" color="accent" (click)="antragFreigeben(row.data)"
                  matTooltip="Alle Checks seitens Maklerservice erledigt, Antrag freigeben">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-row"
          [ngClass]="{'expanded': row.isExpanded, 'marked': row.data.id === (markedPolintSubject | async), 'offenemaklerantraege-row': true}"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedColumn']; when: isExpansionDetailRow"
          [@detailExpand]="row.isExpanded ? 'expanded' : 'collapsed'"
          class="offenemaklerantraege-row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['descriptions']; when: isNonExpandableDetailRow"
          class="border-row, offenemaklerantraege-row"></tr>
    </table>
  </div>
}
<div [ngClass]="listData.dataSource.filteredData.length>30 ? 'custom-pagination' : 'displaynone'">
  <div class="pagination-text">{{ currentPaginationLabel }}</div>
  <mat-paginator class="custom-paginator" (page)="updateLabel()" [hidePageSize]="true" [pageSizeOptions]="[30]"
                 [length]="listData.dataSource.filteredData.length"></mat-paginator>
</div>
@if (listData.dataSource.data.length === 0 || listData.loading) {
  <div class="loading-area">
    @if (listData.loading) {
      <mat-spinner [diameter]="50" strokeWidth="3"></mat-spinner>
    } @else {
      <app-no-data text="Keine Daten gefunden">
      </app-no-data>
    }
  </div>
}

<ng-template #documentTemplate
             let-documentConfigRow="documentConfigRow" let-row="row">
  <div class="add-row">
    <span class="fixed-col gray-text">{{ documentConfigRow.label }}</span>
    <span class="fixed-col">
      <div class="icon-text">
        <span class="check-msg"></span>
          <ng-container
            *ngTemplateOutlet="documentConfigRow.getStatusTemplateRefFunction(row.data.maklerPolizzeDetails)">
          </ng-container>
      </div>
    </span>
    @if (bearbeitenErlaubt) {
      <div class="flex-container">
        <div class="button-col">
          {{ documentConfigRow.getStatusTextFunction(row.data.maklerPolizzeDetails) }}
        </div>
        @if (documentConfigRow.description) {
          <mat-icon class="info-icon"
                    [matTooltip]="documentConfigRow.description"
                    matTooltipPosition="right"
                    matTooltipClass="tooltip-multiline">info_outline
          </mat-icon>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #check_true>
  <mat-icon class="green-icon">
    check_circle
  </mat-icon>
</ng-template>
<ng-template #check_false>
  <mat-icon class="red-icon">
    cancel
  </mat-icon>
</ng-template>
<ng-template #check_undefined>
</ng-template>
